<div class="flex items-center">
	<div class="grow">
		<div class="kamona-button-session">
			<app-kamona-custom-button (submitForm)="submit()"
									  [isBlock]="true"
									  [isSubmitting]="submitting||isCheckingApiMetaMapRef"
									  [text]="text"
									  [type]="'primary'">
			</app-kamona-custom-button>
		</div>
	</div>
	<div class="hidden">
		<metamap-button #KamonaMetaMap (emitVerificationStatus)="verificationCallback($event)"
						[appMetaMapVerification]="metadata"
						[attr.clientid]="clientId" [attr.flowid]="flowId" [attr.metadata]="metadata">
		</metamap-button>
	</div>
</div>
